import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import { SxProps } from '@mui/material';
import { stringAvatar } from '@components/UserAvatar/helpers';

const UserAvatarInitials = ({
  name,
  initials,
  onClick,
  sx = {},
}: {
  name: string;
  initials?: string;
  onClick?: () => void;
  sx?: SxProps;
}) => {
  const avatarProps = stringAvatar((name || '').toUpperCase());
  const displayInitials =
    initials !== undefined ? initials : avatarProps.children;

  return (
    <Avatar onClick={onClick} sx={{ ...sx, ...avatarProps.sx }}>
      {displayInitials || <PersonIcon />}
    </Avatar>
  );
};

export default UserAvatarInitials;
